import React from 'react';

import styled from 'styled-components';

import { getBulkFeatureFlagCountText } from './helpers';
import {
  UserManagementFeatureFlagKeyType,
  UserManagementFeatureFlagOptionType,
  UserManagementFeatureFlagsType,
} from './types';
import UserManagementFeatureFlagsModalRow from './UserManagementFeatureFlagsModalRow';

const FlagsList = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 6px;
  max-height: 380px;
  overflow-y: auto;
  padding-right: 6px;
`;

const FlagCount = styled.div`
  font-size: 12px;
  color: var(--text-secondary);

  &.changed {
    color: var(--button-blue);
    font-family: var(--font-medium);
  }
`;

type Props = {
  availableFlags: UserManagementFeatureFlagOptionType[];
  bulkFeatureFlagChanges: Partial<UserManagementFeatureFlagsType>;
  selectedUsersCount: number;
  onBulkFlagChange: (key: UserManagementFeatureFlagKeyType, value: boolean) => void;
  onBulkFlagOptionClick: (key: UserManagementFeatureFlagKeyType, value: boolean) => void;
};

const UserManagementFeatureFlagsModalBulkList = ({
  availableFlags,
  bulkFeatureFlagChanges,
  selectedUsersCount,
  onBulkFlagChange,
  onBulkFlagOptionClick,
}: Props) => (
  <FlagsList>
    {availableFlags.map((flag) => {
      const changed = bulkFeatureFlagChanges[flag.key] !== undefined;

      return (
        <UserManagementFeatureFlagsModalRow
          key={flag.key}
          flag={flag}
          changed={changed}
          value={bulkFeatureFlagChanges[flag.key]}
          detail={
            <FlagCount className={changed ? 'changed' : undefined}>
              {getBulkFeatureFlagCountText(
                flag.enabled_count ?? 0,
                flag.selected_count ?? selectedUsersCount,
                bulkFeatureFlagChanges[flag.key]
              )}
            </FlagCount>
          }
          dataTestIdPrefix="user-management-bulk-feature-flag"
          onChange={onBulkFlagChange}
          onOptionClick={onBulkFlagOptionClick}
        />
      );
    })}
  </FlagsList>
);

export default UserManagementFeatureFlagsModalBulkList;
